import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import { useTranslation } from "react-i18next";
import WaitlistCTA from "@/components/home/WaitlistCTA";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [];

export default function FAQ() {
  const { t } = useTranslation();
  const items = t("content.faq.items", { returnObjects: true }) || FAQS;
  return (
    <>
      <SEO
        slug="faq"
        title="FAQ · Twenty honest answers — Instantxfer CashApp"
        description="The questions our beta testers actually asked — fees, timing, limits, corridors, security. Answered without spin."
      />
      <PageHero
        eyebrow={t("pageHero.faq.eyebrow")}
        title={t("pageHero.faq.title")}
        italic={t("pageHero.faq.italic")}
        body={t("pageHero.faq.body")}
        testId="faq-hero"
      />
      <section className="pb-24 md:pb-32 bg-canvas">
        <div className="container-x max-w-3xl">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map((item, i) => (
              <AccordionItem key={i} value={`i-${i}`} className="border-b border-forest/10">
                <AccordionTrigger
                  className="text-left font-display text-xl md:text-2xl text-forest hover:no-underline py-6"
                  data-testid={`faq-q-${i}`}
                >
                  <span className="flex items-start gap-4">
                    <span className="font-mono text-[11px] tracking-[0.22em] text-ink/40 pt-2">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{item.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="text-ink/70 text-base leading-relaxed pb-6 pl-12"
                  data-testid={`faq-a-${i}`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <WaitlistCTA />
    </>
  );
}
